import notifier from '../notifier.js';

import axios from 'axios';


export function processError(err) {
  if(axios.isCancel(err)) {
    return;
  }

  notifier.showError(err);
}
